import { Controller, Get, UseGuards } from '@nestjs/common';
import { ApiOperation, ApiTags } from '@nestjs/swagger';
import { AdminAccessGuard } from '../auth/admin-access.guard';
import { AuthGuard } from '../auth/auth.guard';
import { StoreContextService } from '../tenancy/store-context.service';
import { ReadinessService } from './readiness.service';

@ApiTags('readiness')
@Controller('admin/readiness')
@UseGuards(AuthGuard, AdminAccessGuard)
export class ReadinessController {
  constructor(
    private readonly readiness: ReadinessService,
    private readonly storeContext: StoreContextService
  ) {}

  @Get()
  @ApiOperation({ summary: 'What this store still needs before it can sell' })
  report() {
    return this.readiness.report(this.storeContext.storeId());
  }
}
